import { type RouteObject, Outlet } from 'react-router';
import { MyTasks } from 'modules/tasks/MyTasks';
import { MyWork } from 'modules/tasks/MyWork';
import { Breadcrumb } from 'components';
import { Header } from 'components/Header';
import { MenuItem, MenuList } from '@ff-it/ui';
import { NavLink } from 'react-router-dom';

export const route: RouteObject = {
  path: 'tasks',
  element: (
    <>
      <Breadcrumb>Tasks</Breadcrumb>
      <Header
        // heading="Tasks"
        menu={
          <MenuList variant="pills" direction="horizontal">
            <MenuItem label="My work" component={NavLink} to="" end />
            <MenuItem label="My tasks" component={NavLink} to="my_tasks" />
          </MenuList>
        }
      />
      <Outlet />
    </>
  ),
  children: [
    {
      index: true,
      element: <MyWork />,
    },
    {
      path: 'my_tasks',
      element: <MyTasks />,
    },
  ],
};
